function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { consumeProperty, dirtyProperty } from './validator-versions.js';
var _object = /*#__PURE__*/new WeakMap();
class PropertyStorageMap {
  constructor(object) {
    _classPrivateFieldInitSpec(this, _object, void 0);
    _classPrivateFieldSet(_object, this, object);
  }
  consume(key) {
    consumeProperty(_classPrivateFieldGet(_object, this), key);
  }
  update(key) {
    dirtyProperty(_classPrivateFieldGet(_object, this), key);
  }
}
export { PropertyStorageMap };